import { EkycStatus } from '../../enum/ekyc-status.enum';
import { IdentificationType } from '../../enum/identification-type.enum';
import { InvestorType } from '../../enum/investor-type.enum';
import { AttachmentInfo } from '../attachment/attachment-info';

export class UserProfile {
  id: string;
  phoneNumber: string;
  phoneCountryCode: string;
  fullName: string;
  email: string;
  birthday: string;
  aboutMe: string;
  address: string;
  postcode: string;
  city: string;
  stateId: string;
  countryId: string;
  photoAttachmentUrl: string;
  ekycStatus: EkycStatus;
  timeZone: string;
  identityNo: string;
  nationality: string;
  userIdentityNoType: IdentificationType;
  occupationType: number;
  employmentSector: number;
  othersOccupationType: string;
  grossAnnualIncomeType: number;
  sourceOfWealth: number[];
  transactionPurpose: number;
  othersSourceOfWealth: string;
  sourceOfFunds: number[];
  othersSourceOfFunds: string;
  pepDeclaration: boolean;
  companyRepPositionType: number;
  othersCompanyRepPositionType: string;
  isPEPDeclaration: boolean;
  ecfAccountNo: string;
  blockchainAddress: string;
  blockchainExplorerUrl: string;
  favouriteSector: number[];
  isMYsecAvailable: boolean;
  attachmentInfo: AttachmentInfo;
  completeEkyc?: boolean;
  isMasterRep?: boolean;
  brandName?: string;
  companyId?: number;
  companyName?: string;
  companyType?: number;
  registrationNumber?: string;
  incorporatedDate?: string;
  investorType?: InvestorType;
  twoFactorEnabled: boolean;
  hasTransaction: boolean;
  /**
   * INC-329 — the server-side ADR-0015 Flagged predicate, the SAME one the login response
   * carries. Read here rather than from the login response so the profile-refresh interrupt
   * can be raised after the investor has landed and still survive a page refresh.
   *
   * Only the individualInvestor projection of this endpoint returns it, so it is optional:
   * on any other role's profile it is simply absent, and absent means "do not interrupt".
   */
  isProfileRefreshRequired?: boolean;
}
